
























import Vue from 'vue'
import {
  Component, Prop, Emit, Watch,
} from 'vue-property-decorator';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';
import ModalComponent from '@/shared/modal/modal.component.vue'
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import ModalOptions from '@/shared/modal/modal-options.entity';
import Contract from '@/domain/contract/entity/contract.entity';

@Component({
  components: {
    ModalComponent,
    VbTooltipSlot,
    LabelSlot,
  },
})
export default class ReOpenContractModal extends Vue {
  @Prop({ required: true })
  show!: boolean;

  @Prop({ required: true, default: '' })
  businessUnitId!: string;

  @Prop({
    required: true,
  })
  contract!: Contract;

  @Prop({ required: true })
  isContractGroup!: boolean;

  justificationText: string = '';

  handleConfirm() {
    this.$emit('ok', this.justificationText);
  }

  @Emit('cancel')
  cancel(): void {}

  get options(): ModalOptions {
    const title = this.isContractGroup ? 'Reabertura de Grupo de Contrato' : 'Reabertura de Contrato';
    return {
      title,
      titleAlign: 'center',
      showClose: false,
      showOk: true,
      labelOk: 'Salvar',
      okColor: 'bluePrimary',
      showCancel: true,
      labelCancel: 'Cancelar',
      width: 720,
      persistent: true,
    }
  }
}
